export const eFakturaTrackingIDs = {
    shareEFaktura: {
        id: 'dagligbank-share-efaktura',
    },
    deleteSharedEFaktura: {
        id: 'dagligbank-delete-share-efaktura',
    },
    deleteReceivedEFaktura: {
        id: 'dagligbank-delete-received-efaktura',
    },
    updateSharedEFaktura: {
        id: 'dagligbank-update-share-efaktura',
    },
    batchEFaktura: {
        id: 'dagligbank-batch-efaktura',
    },
};
